// Types
import { SearchAction } from './types'

// Action types
import { SEARCH } from './actionTypes'

export const searchQuery = (query: string): SearchAction => ({
  type: SEARCH,
  query
})
